import { useQuery } from '@tanstack/react-query';
import { ConversationFile } from 'src/secret-menu/conversation-debugger/types';

export const useConversationFiles = (conversationId: string | null, tenantName: string | null) => {
  const { data, isLoading, isError } = useQuery<ConversationFile[]>({
    queryKey: ['admin', 'conversations', conversationId, 'files', { tenantName }],
    enabled: !!conversationId && !!tenantName,
  });

  return { files: data, isLoading, isError };
};
